/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CategoryCell_lists$ref: FragmentReference;
declare export opaque type CategoryCell_lists$fragmentType: CategoryCell_lists$ref;
export type CategoryCell_lists = {|
  +id: string,
  +$refType: CategoryCell_lists$ref,
|};
export type CategoryCell_lists$data = CategoryCell_lists;
export type CategoryCell_lists$key = {
  +$data?: CategoryCell_lists$data,
  +$fragmentRefs: CategoryCell_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CategoryCell_lists",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Lists"
};
// prettier-ignore
(node/*: any*/).hash = '5d389958141c69fd735bd1d59d3b9e51';

module.exports = node;
